import { useQuery } from "react-query"
import { getProposalsReport, getTenantReport } from "./api"

export const useGetTenantReport = (startDate: string, endDate: string) => {
  return useQuery(['tenantReport'], () => getTenantReport(startDate, endDate))
}

export const useGetProposalsReport = (startDate: string, endDate: string) => {
  return useQuery(['proposalsReport'], () => getProposalsReport(startDate, endDate))
}